import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import { FC, MouseEvent, useState } from 'react';
import palette from '../../../../shared/lib/theme/palette';
import { listItemWrapper } from '../../../../shared/lib/theme/styleConstants';
import { useAppContext } from '../../app/contexts/AppContext';
import { EditCardMenuProps } from '../../app/interfaceTypes';
import { ActionType } from '../../app/reducer/AppContextReducer';
import { useMobileView } from '../../app/hooks/useMobileView';

export const EditCardMenu: FC<EditCardMenuProps> = ({ contact, contactIndex, handleVip }) => {
  const { dispatch, cardsData, isDelete, isEditContact, isChangePriority, currentUser } = useAppContext();
  const { isSubscribed } = currentUser ?? {};
  const { subscriptionCancelled } = isSubscribed ?? {};
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { id, priority } = contact ?? {};
  const currentCard = cardsData?.filter((card) => card.id === id);

  const vipContact = cardsData?.find((card) => card.priority === 1);

  const { red } = palette;
  const mediumViewPort = useMobileView();

  const handleVipContact = async () => {
    setAnchorEl(null);
    if (vipContact && contact && handleVip) {
      await handleVip(vipContact, contact);
    }
  };

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const editOpen = () => {
    dispatch({ type: ActionType.SET_IS_EDIT_CONTACT, isEditContact: !isEditContact });
    dispatch({ type: ActionType.SET_CURRENT_CARD, currentCardData: currentCard?.[0] });
    dispatch({ type: ActionType.SET_CONTACT_INDEX, contactIndex: contactIndex });
    setAnchorEl(null);
  };

  const handleDeleteOpen = () => {
    dispatch({ type: ActionType.SET_CURRENT_CARD, currentCardData: currentCard?.[0] });
    dispatch({ type: ActionType.SET_IS_DELETE, isDelete: !isDelete });
    setAnchorEl(null);
  };

  const handleChangePriorityOpen = () => {
    dispatch({ type: ActionType.SET_CURRENT_CARD, currentCardData: currentCard?.[0] });
    dispatch({ type: ActionType.SET_IS_CHANGE_PRIORITY, isChangePriority: !isChangePriority });
    setAnchorEl(null);
  };

  return (
    <Box position="absolute" top="10px" right="10px">
      <IconButton id="basic-button" aria-controls={open ? 'basic-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined} onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>

      <Menu
        sx={listItemWrapper}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuItem onClick={editOpen}>View</MenuItem>

        {mediumViewPort && cardsData.length > 1 && <MenuItem onClick={handleChangePriorityOpen}>Swap Priority</MenuItem>}

        {priority !== 1 && <MenuItem onClick={handleVipContact}>Make VIP</MenuItem>}

        <MenuItem sx={{ color: `${red} !important` }} onClick={handleDeleteOpen} disabled={subscriptionCancelled ?? false}>
          Delete
        </MenuItem>
      </Menu>
    </Box>
  );
};
